import { useCallback, useState } from "react";

export function usePendingBodyMeshLoads({ pendingMeshLoadBodyCountsRef }) {
  const [pendingMeshLoadBodyVersion, setPendingMeshLoadBodyVersion] = useState(0);

  const updatePendingMeshLoadBodyCount = useCallback(
    (bodyUuid, delta) => {
      if (!bodyUuid) return;
      const key = String(bodyUuid);
      const counts = pendingMeshLoadBodyCountsRef.current;
      const next = (counts.get(key) || 0) + delta;
      if (next > 0) counts.set(key, next);
      else counts.delete(key);
      setPendingMeshLoadBodyVersion((version) => version + 1);
    },
    [pendingMeshLoadBodyCountsRef]
  );

  const registerPendingBodyMeshLoad = useCallback(
    (promise, bodyUuid) => {
      if (!promise || typeof promise.then !== "function" || !bodyUuid) return;
      updatePendingMeshLoadBodyCount(bodyUuid, 1);
      Promise.resolve(promise).finally(() => {
        updatePendingMeshLoadBodyCount(bodyUuid, -1);
      });
    },
    [updatePendingMeshLoadBodyCount]
  );

  return {
    pendingMeshLoadBodyVersion,
    registerPendingBodyMeshLoad,
    updatePendingMeshLoadBodyCount,
  };
}
